import { countryListArray } from "src/constants/countryList";

export const LEGAL_STRUCTURE_OPTIONS = [
    { label: "Community Interest Company (CIC)", value: "cic" },
    { label: "Cooperative", value: "cooperative" },
    { label: "Charitable Incorporated Organisation", value: "charitable" },
    { label: "Sole Trader/partnership", value: "soleTrader" },
    { label: "Limited Company", value: "limitedCompany" },
    { label: "Limited Company with specific changes to Articles of Association to include society and environment as stakeholders (i.e. B-Corp)", value: "bCorp" },
    { label: "Other", value: "other" },
]

export const MATERIALITY_ASSESSMENT_OPTIONS = [
    { label: "None", value: "none" },
    { label: "Single", value: "single" },
    { label: "Double", value: "double" },
]

export const INTRO_QUESTIONS = [
    {
        label: "What's your organisation called?",
        name: "orgName",
        placeholder: "Enter organisation name",
    },
    {
        label: "What period are you assessing your organisation for?",
        name: "reportingPeriod",
        placeholder: "Select reporting period",
        info:"This should reflect the most recent calendar or financial year for example, and be a period of time that you can evidence your environmental, social and governance impacts and interventions over."
    },
    {
        label: "What's your company number?",
        name: "companyNumber",
        placeholder: "Enter company number",
    },
    {
        label: "What country is your organisation registered in?",
        name: "country",
        placeholder: "Select country",
        options: countryListArray
    },
    {
        label: "What's your organisation's web address?",
        name: "website",
        placeholder: "Enter website",
    },
    // {
    //     label: "What's your name?",
    //     name: "name",
    //     placeholder: "Enter name",
    // },
    {
        label: "What's your contact email address?",
        name: "email",
        placeholder: "Enter email",
    },
    {
        label: "What was your most recent materiality assessment?",
        name: "materialityAssessment",
        placeholder: "Select materiality assessment",
        options: MATERIALITY_ASSESSMENT_OPTIONS,
        info: "A materiality assessment is a formal exercise aimed at engaging external stakeholders to find out how important Environmental, Social and Governance (ESG) issues are to them.",
    },
    {
        label: "What is your organisation's legal structure?",
        name: "legalStructure",
        placeholder: "Select legal structure",
        options: LEGAL_STRUCTURE_OPTIONS,
    }]